import React, { useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"

const SimpleTextComponent = props => {
  const { classes } = props;

  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  
  let handleTextChange = (value) => {
    setError(checkForErrors(value))
    props.handleChange("txtField", value , props.iteration, checkForErrors(value))
  }

  let checkForErrors = (value) => {
    if (checkIfBlank(value)) {
      setErrorMessage("Field cannot be blank")
      return true 
    } else if (checkRegexErrors(value)) {
      setErrorMessage(props.apiRegex.name.errorMessage)
      return true
    } else {
      setErrorMessage("")
      return false
    }
  }

  let checkIfBlank = (value) => {
    return value === "" ? true : false
  }

  let checkRegexErrors = (value) => {
    if (props.selectedValue !== "name") {
      return false
    } else {
      return !props.apiRegex.name.regex.test(value)
    }
  }

  return (
    <div>
      <GridContainer
          className={classes.containerLine}
          alignItems="center"
      >
          <GridItem xs={6}>
              <FormLabel className={classes.labelHorizontal}>
                  Please type new value
              </FormLabel>
          </GridItem>
          <GridItem xs={6}>
              <TextField
                  required
                  id={"txtId" + props.iteration}
                  error={isError}
                  label="Required"
                  onChange={(event) => {
                          handleTextChange(event.target.value)
                      }
                  }
                  className={classes.txtField}/>
                  {errorMessage}
          </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(styles)(SimpleTextComponent);
